import Blue from "~/core";

new Blue({
	name: 'Keyboard Control Outline',
	selector: "body",
	setup(body) {
    this.$addEvents(body, 'mousedown', () => body.classList.add('using-mouse'));
    this.$addEvents(body, 'keydown', () => body.classList.remove('using-mouse'));
	}
});

new Blue({
	name: 'Scroll Direction',
	selector: 'body',
	setup(body) {
		const root = document.documentElement;
		let scrollPos = 0;

		const handleScroll = () => {
			const top = body.getBoundingClientRect().top;
			if (top > scrollPos) {
				root.setAttribute('data-scroll-direction', 'UP');
			} else {
				root.setAttribute('data-scroll-direction', 'DOWN');
			}
			scrollPos = top;
		};

		this.$addEvents(window, 'scroll once', handleScroll);
	},
});
